import React, { useReducer, useEffect } from 'react';

import {
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  FormHelperText,
  makeStyles
} from '@material-ui/core';

import { validate } from '../../../utils/validators';
import './Input.css';

const useStyles = makeStyles((theme) => ({
  prod: {
    backgroundColor: theme.palette.background.dark,
  },
  label: {
    backgroundColor: 'white'
  }
}));

const inputReducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH':
      return {
        ...state,
        isTouched: true
      };
    default:
      return state;
  }
};
const Input = (props) => {
  const {
    id,
    placeholder,
    label,
    data,
    blank,
    fullWidth,
    variant,
    onInput,
    validators,
    initialValue,
    initialValid,
    InputLabelProps,
    errorText,
    dica,
    onChange,
    multiple,
    estilos,
    disabled
  } = props;
  const classes = useStyles();
  const [inputState, dispatch] = useReducer(inputReducer, {
    value: initialValue || (multiple !== undefined ? [] : ''),
    isValid: initialValid || false,
    isTouched: initialValid || false
  });

  const {
    value,
    isValid
  } = inputState;

  useEffect(() => {
    onInput(id, value, isValid);
  }, [id, value, isValid, onInput]);

  const changeHandler = (event) => {
    console.log(event.target.value);
    dispatch({ type: 'CHANGE', val: event.target.value, validators });
    if (onChange) {
      onChange(event.target.value);
    }
  };
  const touchHandler = (event) => {
    console.log(event);
    dispatch({ type: 'TOUCH' });
  };

  return (
    <FormControl variant={variant} style={{ marginTop: '15px', marginBottom: '0px', ...estilos }} fullWidth={fullWidth} error={!inputState.isValid && inputState.isTouched}>
      <InputLabel shrink className={classes.label} fullWidth={fullWidth} id={id} props={InputLabelProps}>{placeholder}</InputLabel>
      <Select
        labelId={id}
        label={label}
        displayEmpty
        value={inputState.value}
        onChange={changeHandler}
        fullWidth={fullWidth}
        disabled={disabled}
        onOpen={touchHandler}
        multiple={multiple}
      >
        <MenuItem value="">
          <em>{blank}</em>
        </MenuItem>
        {data.map((cat) => (
          <MenuItem value={cat.id}>{cat.label}</MenuItem>
        ))}
      </Select>
      <FormHelperText>{!inputState.isValid && inputState.isTouched ? errorText : dica}</FormHelperText>
    </FormControl>
  );
};
export default Input;
